import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const documentNotesService = {
  createNote,
  getNote,
  editNote,
  deleteNote
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'DocumentNotes'
};

function extract(r) {
  return r.data;
}

async function createNote(DocumentVersionsFileCode: string, FileNote: string) {
  return axios.post(`${model.baseUrl}${model.controller}/Create`, {
    DocumentVersionsFileCode: DocumentVersionsFileCode,
    FileNote: FileNote
  }).then(extract);
}

async function getNote(DocumentVersionsFileNoteCode: string) {
  return axios.get(`${model.baseUrl}${model.controller}/Get?documentVersionsFileNoteCode=${DocumentVersionsFileNoteCode}`).then(extract);
}

async function editNote(DocumentVersionsFileCode: string, FileNote: string) {
  return axios.patch(`${model.baseUrl}${model.controller}/Edit`, {
    DocumentVersionsFileCode: DocumentVersionsFileCode,
    FileNote: FileNote
  }).then(extract);
}

async function deleteNote(DocumentVersionsFileNoteCode: string) {
  return axios.delete(`${model.baseUrl}${model.controller}/Delete/` + DocumentVersionsFileNoteCode).then(extract);
}
